import { forwardRef, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { AppConst } from 'consts';

const RoadmapSection = forwardRef<HTMLDivElement, {}>((props, ref) => {
	const [inViewRef1, inView1] = useInView({
		delay: AppConst.InViewDelay,
		rootMargin: AppConst.InViewMargin,
	});
	const [inViewRef2, inView2] = useInView({
		delay: AppConst.InViewDelay,
		rootMargin: AppConst.InViewMargin,
	});
	const [inViewRef3, inView3] = useInView({
		delay: AppConst.InViewDelay,
		rootMargin: AppConst.InViewMargin,
	});
	const [inViewRef4, inView4] = useInView({
		delay: AppConst.InViewDelay,
		rootMargin: AppConst.InViewMargin,
	});

	const controls1 = useAnimation();
	const controls2 = useAnimation();
	const controls3 = useAnimation();
	const controls4 = useAnimation();

	useEffect(() => {
		if (inView1) {
			controls1.start('visible');
		} else {
			controls1.start('hidden');
		}
	}, [controls1, inView1]);

	useEffect(() => {
		if (inView2) {
			controls2.start('visible');
		} else {
			controls2.start('hidden');
		}
	}, [controls2, inView2]);

	useEffect(() => {
		if (inView3) {
			controls3.start('visible');
		} else {
			controls3.start('hidden');
		}
	}, [controls3, inView3]);

	useEffect(() => {
		if (inView4) {
			controls4.start('visible');
		} else {
			controls4.start('hidden');
		}
	}, [controls4, inView4]);

	return (
		<div className="bg-grey" ref={ref}>
			<Container className="pt80 pb40" ref={ref}>
				<Row>
					<h2 className="center">Roadmap</h2>
					<div ref={inViewRef1}>
						<motion.div
							animate={controls1}
							initial="hidden"
							variants={{
								hidden: { y: 300, opacity: 0 },
								visible: { y: 0, opacity: 1 },
							}}
							transition={{ type: 'spring', duration: 0.5 }}
						>
							<h3 className="center pt20">What is coming?</h3>
							<p className="center">
								Unlike other projects that promise the world, MTG aims to be transparent on what we
								can offer our valued holders overtime as we grow this strong community together and
								do not want to promise the world on things we won’t deliver on.
							</p>
						</motion.div>
					</div>

					<div ref={inViewRef4}>
						<motion.div
							animate={controls4}
							initial="hidden"
							variants={{
								hidden: { y: 300, opacity: 0 },
								visible: { y: 0, opacity: 1 },
							}}
							transition={{ type: 'spring', duration: 0.5, delay: 0.5 }}
						>
							<h3 className="center pt20">So what is there to look forward to?</h3>
							<p className="center">
								We kick things off toward the end of the year with our mint and our MTG Battle
								station game. Within the game our holders will be able to stake their More than
								Gamers in the battle lounge where they will earn precious ArcadaTokens and Lifeline
								tokens.
								<br />
								Arcada Tokens will serve as a ticket to fight the royal elites of the MTG metaverse
								in the battle arena with a % chance of winning 1/100 super rare royal elite members
								of the metaverse. Lifeline tokens are needed to stay alive in the metaverse, so make
								sure you are collecting them as well.
							</p>
							<p className="center">
								2022 we open the doors to our MTG derivative competition where artists show off the
								more than gamer in their own unique style, winners are decided by community vote and
								will be rewarded with an eth prize!
							</p>
						</motion.div>
					</div>

					<div ref={inViewRef2}>
						<motion.div
							animate={controls2}
							initial="hidden"
							variants={{
								hidden: { y: 300, opacity: 0, transition: { delay: 0 } },
								visible: { y: 0, opacity: 1 },
							}}
							transition={{ type: 'spring', duration: 0.5, delay: 0.5 }}
						>
							<h3 className="center pt20">Taking MTG physical</h3>
							<p className="center">
								Figurine manufacturing will be available mid 2022 along with our MTG Merchandise
								range.
							</p>
							<p className="center">
								Our team at MTG are all heavily involved in the esports industry in one way or
								another, we love the concept of giveaways for holders but we would be more excited
								to arrange future tournaments of all types of games for our holders where winners
								will receive exclusive prizes and rewards.
							</p>
							<p className="center">
								The More Than Gamers story still has so many layers which have not been unfolded
								yet, villains to welcome in and heroes to be crowd. The origin story is forever
								evolving and we will continue to reveal and show our community what our MTG
								characters are capable of achieving in the gamers metaverse ruled by the Royal
								Elites.
							</p>
							<p className="center">
								We have established connections with TV studios to turn the More Than Gamers story
								into a small series. We will devote our time and effort in order to make this a
								reality. For our community to see their characters come to life on screen would
								bring great joy to our team.
							</p>
						</motion.div>
					</div>

					<div ref={inViewRef3}>
						<motion.div
							animate={controls3}
							initial="hidden"
							variants={{
								hidden: { y: 300, opacity: 0, transition: { delay: 0 } },
								visible: { y: 0, opacity: 1 },
							}}
							transition={{ type: 'spring', duration: 0.5, delay: 0.5 }}
						>
							<h3 className="center pt20">Summary</h3>
							<p className="center">
								10,000 MTG
								<br />
								10% of secondary sales to charity
								<br />
								In-game staking to face the elite of the metaverse! (receive a 1/100)
								<br />
								Community derivative projects
								<br />
								Merchandise + 3-D figurines
								<br />
								Small animation series
								<br />
								More to be announced
							</p>
						</motion.div>
					</div>
				</Row>
			</Container>
		</div>
	);
});

export default RoadmapSection;
